import { Injectable } from "@angular/core";
import { ServiceConfig } from "./service-config";
import { Headers } from "@angular/http";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class SmmPageService {
  private host = ServiceConfig.host;
  private baseUrl = this.host + "/api/ipcc/";
  private data: any;
  constructor(private http: HttpClient) {
    this.data = JSON.parse(localStorage.getItem("currentSmmData"));
  }

  public searchPageByIdOrLink(from, size, id) {
    const body = {
      from: from,
      size: size,
      filter: {},
    };

    const idPattern = "^[0-9]+$";
    console.log("id : ", id);
    if (id.toLowerCase().match(idPattern) !== null) {
      body.filter["id"] = id;
    } else {
      if (id.indexOf("https://") > -1) {
        body.filter["link"] = id;
      } else {
        body.filter["username"] = id;
      }
    }
    let url = this.baseUrl + "/page/search?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getPageById(id) {
    let url = this.baseUrl + "/page/get/" + id + "?token=" + this.data.token;
    return this.http.get<any>(url);
  }

  public searchPages(from, size, bool, orderBy) {
    const body = {
      size: size,
      from: from,
      orderBy: orderBy,
      filter: bool,
    };
    let url = this.baseUrl + "/page/search?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public removePriority(body) {
    let url = this.baseUrl + "/page/removePriority?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getListPagePriority(body) {
    let url =
      this.baseUrl + "/page/getListPagePriority?token=" + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getPage(pageId) {
    let url = this.baseUrl + 'page/getPage/'+ pageId + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/smm-page.service.ts